/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import { mapMutations } from 'vuex';

export default {

  props: {
    vmpData: {
      required: true,
      type: Object,
    },
    onConfirm: {
      required: true,
      type: Function,
      default: () => {},
    },
  },

  computed: {
    vmpDataList() {
      return Object.entries(this.vmpData).filter(([key, value]) => value && !Array.isArray(value)).map(([key, value]) => ({
        label: this.$t(`form.products.${key}.label`),
        value,
      }));
    },

  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),
    confirmSync() {
      this.onConfirm(this.vmpData);
      this.closeModal();
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/vmpSyncConfirmPopup/vmpSyncConfirmPopup.js